import loadable from '@loadable/component';

export const BusinessEntityFlowRootLoadable = loadable(() => import('./BusinessEntityFlowRoot'), {
  fallback: null,
  ssr: false,
});
